
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aidashboard",
      function () {
        return require("private-next-pages/aidashboard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aidashboard"])
      });
    }
  